import { type TChartData } from "./CompletionChart";

export const defaultCompletionStats: TChartData = {
    title: "questions",
    seriesKeys: ["validated", "answered", "notAnswered"],
    dataRows: [
        {
            completion: "overall",
            answered: 0,
            validated: 0,
            notAnswered: 0,
        },
    ],
    seriesConfig: {
        answered: {
            label: "answered",
            color: "#34C780",
        },
        validated: {
            label: "validated",
            color: "#03A365",
        },
        notAnswered: {
            label: "notAnswered",
            color: "#E6E6E6",
        },
    },
};

export const defaultAiSuggestionStats: TChartData = {
    title: "aiSuggestion",
    seriesKeys: [
        "aiSuggestionSuccess",
        "aiSuggestionFailed",
        "aiSuggestionNotStarted",
    ],
    dataRows: [
        {
            completion: "aiSuggestion",
            aiSuggestionSuccess: 0,
            aiSuggestionFailed: 0,
            aiSuggestionNotStarted: 0,
        },
    ],
    seriesConfig: {
        aiSuggestionSuccess: {
            label: "aiSuggestionSuccess",
            color: "#BE2FBE",
        },
        aiSuggestionFailed: {
            label: "aiSuggestionFailed",
            color: "#FFC700",
        },
        aiSuggestionNotStarted: {
            label: "aiSuggestionNotStarted",
            color: "#E6E6E6",
        },
    },
};
